<template>
  <div v-if="basePlans">
    <PTabs :tabs="categoryTabs"
           :selected="category"
           align-left
           pills
           class="plan-tabs"
           @select="onSelectCategory"
           v-if="categoryTabs.length > 1"/>
    <BasePlanSwitcher
      :plans="basePlans"
      :trialPlan="trialPlan"
      :plan="chosenPlan"
      :currency="currency"
      :is-ecommerce="isEcommerce"
      @change="$emit('change', $event)"
      v-if="basePlans.length > 0"
    />
    <div class="contact-us-section d-flex flex-column align-items-start mt-1">
      <CIcon name="cipBriefcase02" size="custom" :height="20" class="mb-2 text-muted"/>
      <span
        class="mb-2"
        v-translate
        translate-context="category_selector.contact_us"
      >
    Do you have special needs? Request a <strong>custom solution</strong> directly from our team
    </span>
      <a class="text-primary font-weight-semi-bold" style="cursor: pointer" @click="onContactUs"
         v-translate translate-context="category_selector.contact_us">Contact us</a>
    </div>
  </div>
</template>

<script>
import PTabs from "@/domain/core/components/PTabs.vue";
import BasePlanSwitcher from "@/domain/events/components/BasePlanSwitcher.vue";

export default {
  name: "CategorySelector",
  components: {BasePlanSwitcher, PTabs},
  emits: ['change', 'moveNext'],
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    currency: {
      type: String,
      required: true
    },
    selected: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      category: null,
      chosenPlan: null
    }
  },
  mounted() {
    for (const category of this.categories) {
      if (this.selected && category.base_plans.find(plan => plan.id === this.selected)) {
        this.category = category.name;
        return;
      }
    }
    if (!this.category)
      this.category = this.categoryTabs[0].name;
  },
  computed: {
    categoryTabs() {
      return this.categories
        .filter(category => !category.is_trial)
        .map(category => ({
          name: category.name,
          label: category.name,
        }));
    },
    basePlans() {
      if (!this.category) return []
      const category = this.categories.find(category => category.name === this.category)
      return [...category.base_plans].sort((a, b) => a.price - b.price)
    },

    isEcommerce() {
      if (!this.category) return false
      const category = this.categories.find(category => category.name === this.category)
      return category ? category.is_ecommerce === true : false
    },
    trialPlan() {
      for (const category of this.categories) {
        const trialPlan = category.base_plans.find(plan => plan.is_trial === true);
        if (trialPlan) {
          return trialPlan;
        }
      }
      return null;
    }
  },
  methods: {
    async onSelectCategory(name) {
      this.category = name
    },
    onContactUs() {
      const url = this.$pgettext('event.modal.create_new_event.contact_us', 'https://business.getpica.com/request-demo/')
      window.open(url, '_blank')
    },
  }
}
</script>